import { render } from "./esteghdam.vue?vue&type=template&id=d010e45a"
import script from "./esteghdam.vue?vue&type=script&lang=js"
export * from "./esteghdam.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/poshakjojomama-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__